import React from 'react';
import {Container, Divider, Grid, Header, Icon, Message} from 'semantic-ui-react';
import {base} from '../helper/base-helper.js';

import ActionCard from './ActionCard.js';
import ResultScrnButtons from './ResultScrnButtons.js';
import ResultRequirements from './ResultRequirements.js';
import ResultHowTo from './ResultHowTo.js';


class ResultScrn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requirements: {},
      howTos: {},
      loading: true
    }
  }

  componentDidMount() {
    let dataCollected = {};

    base.fetch('/actions', {
        context: this,
        queries: {
          orderByChild: 'url',
          equalTo: this.props.match.params.actionURL
        }
      })
      .then( (acyData) => {
        const actionKey = Object.keys(acyData)[0];

        dataCollected.action = acyData[actionKey];
        dataCollected.action.actionId = actionKey

        const getChannel = base.fetch(`/channels/${dataCollected.action.chanId}`, {
            context: this,
          });

        const getRequirements = base.fetch('/requirements/', {
            context: this,
            queries: {
              orderByChild: 'actionId',
              equalTo: dataCollected.action.actionId
            }
          });

        const getHowTos = base.fetch('/howtos/', {
            context: this,
            queries: {
              orderByChild: 'actionId',
              equalTo: dataCollected.action.actionId
            }
          });

        Promise.all([getChannel, getRequirements, getHowTos])
        .then((values) => {

          dataCollected.channel = values[0];
          dataCollected.requirements = values[1];
          dataCollected.howTos = values[2];

          this.setState({
            ...dataCollected,
            loading: false
          })

        })
        .catch(err => console.error(err))
    });
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {

    return (
      <Container className='scrnWrap'>
        <Header as='h1' icon textAlign='center'>
          <Icon name='database' circular />
          <Divider hidden />
          <Header.Content>
            Database Results for:
          </Header.Content>
        </Header>
        <ActionCard addClass='resultCard' action={this.state.action} channel={this.state.channel} />
        <Divider hidden />
        {
          (!this.state.loading) ?
            <ResultScrnButtons user={this.props.user} action={this.state.action} channel={this.state.channel} />
            : ''
        }
        <Divider hidden />
        <Grid centered relaxed stackable columns={2}>
          <Grid.Column>
            <Header as='h2' attached='top'>
              <Icon name='tasks' />
              <Header.Content>
                Requirements
                <Header.Subheader>
                  You need this to get it done:
                </Header.Subheader>
              </Header.Content>
            </Header>

              <ResultRequirements loading={this.state.loading} requirements={this.state.requirements} />

            <Message size='small' attached='bottom'>
              <Icon color='blue' className='attachMsgIcon' name='info circle' />
              <div>
                Requirements missing or found errors? <a>Report Error</a>
              </div>
            </Message>
          </Grid.Column>
          <Grid.Column>
              <Header as='h2' attached='top'>
                <Icon name='lab' />
                <Header.Content>
                  How To
                  <Header.Subheader>
                    A list of useful links for you:
                  </Header.Subheader>
                </Header.Content>
              </Header>

              <ResultHowTo loading={this.state.loading}  howTos={this.state.howTos} />

              <Message size='small' attached='bottom'>
                <Icon color='teal' className='attachMsgIcon' name='idea' />
                <div>
                  You know a kick ass link missing here? <a>Submit Link</a>
                </div>
              </Message>
          </Grid.Column>

        </Grid>
      </Container>
    );
  }

}

export default ResultScrn;



// WEBPACK FOOTER //
// ./src/components/ResultScrn.js